import './Slider'
import './VideoBlock'
import './UiForm'
import './VideoSlider'
import './UiTabs'
import './ScrollActive'


// WEBPACK FOOTER //
// ./src/js/components/index.js